
<template>
  <div @keydown.esc='hide'>
    <a href='#' v-if='can' @click.prevent.stop='toggle' class='company-sidebar__addbtn button button--large button--success'><i class='fas fa-plus'></i>New...</a>
    <slot v-if='isShown'></slot>
  </div>
</template>

<script>
import '../lib/editor';
export default {
  props: ["can"],
  components: {
    
  },
  methods: {
    toggle () {
      this.isShown = !this.isShown;
      if (this.isShown) {
        document.querySelector(".company-jump").style.display = "block";
      } else {
        this.hide()
      }
    },
    hide () {
      document.querySelector(".company-jump").style.display = "none";
    }
  },
  mounted () {
    var that = this;
  },
  data() {
    return {
      isShown: false
    }
  }
}
</script>
